import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CaretLeftIcon } from '../../../../assets/images/caret-left.svg';

const StyledHeader = styled.header<{ $hasChildren: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ $hasChildren }) =>
    $hasChildren ? '0.75rem 1rem 0' : '0.75rem 1rem'};
  border-bottom: 1px solid #e8e9eb;
`;

const StyledHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  align-items: center;
`;

const StyledNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  width: 2rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const StyledCloseButton = styled(StyledNavButton)`
  svg {
    width: 1rem;
    height: 1rem;
  }
`;

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledTitle = styled.h1`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #232323;
  line-height: 1.3;
`;

function CloseIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="#232323"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

type PageHeaderProps = {
  title: React.ReactNode;
  onBack: () => void;
  onClose?: () => void;
  children?: React.ReactNode;
};

export function PageHeader({
  title,
  onBack,
  onClose,
  children,
}: Readonly<PageHeaderProps>) {
  return (
    <StyledHeader $hasChildren={!!children}>
      <StyledHeaderRow>
        <StyledNavButton onClick={onBack} aria-label="Go back">
          <CaretLeftIcon />
        </StyledNavButton>
        <StyledTitleWrapper>
          {typeof title === 'string' ? (
            <StyledTitle>{title}</StyledTitle>
          ) : (
            title
          )}
        </StyledTitleWrapper>
        {onClose ? (
          <StyledCloseButton onClick={onClose} aria-label="Close">
            <CloseIcon />
          </StyledCloseButton>
        ) : (
          <span />
        )}
      </StyledHeaderRow>
      {children}
    </StyledHeader>
  );
}

PageHeader.Title = StyledTitle;
